import Accordion from "components/blocks/Accordion";
import AccordionItem from "components/blocks/Accordion/AccordionItem";
import FormInput from "components/blocks/FormInput";
import { useTranslation } from "react-i18next";
import "./Procedures.scss";
import useSystemDateTheme from "hooks/useSystemDateTheme";
import { OrderUserTypes } from "../../../orderPage.types";
import OrderActionsGrid from "views/home/orders/OrderActionsGrid";
import {NotesType} from "./WorkFlowNotes";

type ProcedureType = {
  data: {
    notes: string;
    phase: string;
    action: string;
    userName: string;
    date: string;
    isActive: boolean;
    isCompleted: boolean;
  }[];
  notes: string; // TODO: is it part of the submission data?
};

const Procedures = ({ orderId }: { orderId: number }) => {
  const { t, i18n } = useTranslation("Orders");
  const { toSystemThemeDateFormat } = useSystemDateTheme();

  const procedures: ProcedureType = {
    data: [
      {
        notes: "الملاحظات",
        phase: "التفديم على البرنامج",
        action: "ارسال",
        userName: "اسم المستخدم",
        date: toSystemThemeDateFormat(new Date()),
        isActive: false,
        isCompleted: true,
      },
      {
        notes: "الملاحظات",
        phase: "تعيين فاحصين",
        action: "الدور",
        userName: "اسم المستخدم",
        date: toSystemThemeDateFormat(new Date()),
        isActive: true,
        isCompleted: false,
      },
      {
        notes: "الملاحظات",
        phase: "تقييم طلب",
        action: "مدير مركز",
        userName: "اسم المستخدم",
        date: toSystemThemeDateFormat(new Date()),
        isActive: false,
        isCompleted: false,
      },
      {
        notes: "الملاحظات",
        phase: "تقييم طلب",
        action: "مدير مركز",
        userName: "اسم المستخدم",
        date: toSystemThemeDateFormat(new Date()),
        isActive: false,
        isCompleted: false,
      },
      {
        notes: "الملاحظات",
        phase: "تقييم طلب",
        action: "مدير مركز",
        userName: "اسم المستخدم",
        date: toSystemThemeDateFormat(new Date()),
        isActive: false,
        isCompleted: false,
      },
      {
        notes: "الملاحظات",
        phase: "تقييم طلب",
        action: "مدير مركز",
        userName: "اسم المستخدم",
        date: toSystemThemeDateFormat(new Date()),
        isActive: false,
        isCompleted: false,
      },
      {
        notes: "الملاحظات",
        phase: "تقييم طلب",
        action: "مدير مركز",
        userName: "اسم المستخدم",
        date: toSystemThemeDateFormat(new Date()),
        isActive: false,
        isCompleted: false,
      },
    ],
    notes: "notes",
  };

  return (
    <Accordion>
      <AccordionItem initiallyOpen title={t("procedures")} elementId={3}>
        <div className="pb-2">
          <OrderActionsGrid
            orderId={orderId}
            visibleColumns={["notes", "workflowName", "action", "appliedBy", "createdOn"]}
          />
          
        </div>
      </AccordionItem>
    </Accordion>
  );
};

export default Procedures;
